export default "../fonts/ab-inspiration-board-active.svg";